module.exports = __webpack_public_path__ + "static/media/cover-noise-in-the-workplace.83e6a9ad.jpg";